"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.kidneyCoreBiopsyMessages = exports.diagnosisBaselineDiseaseMessages = exports.KidneyCoreBiopsy = exports.DiagnosisBaselineDisease = void 0;
const schema_1 = require("../../../../schema");
var DiagnosisBaselineDisease;
(function (DiagnosisBaselineDisease) {
    DiagnosisBaselineDisease["CHRONIC_RENAL_FAILURE"] = "chronic_renal_failure";
    DiagnosisBaselineDisease["GLOMERULONEPHRITIS_HISTOLOGICALLY_NOT_EXAMINED"] = "glomerulonephritis_histologically_not_examined";
    DiagnosisBaselineDisease["FOCAL_SEGMENTAL_GLOMERULOSCLEROSIS_IN_CHILDREN"] = "focal_segmental_glomerulosclerosis_in_children";
    DiagnosisBaselineDisease["IG_A_NEPHROPATHY"] = "IgA_nephropathy";
    DiagnosisBaselineDisease["DENSE_DEPOSIT_DISEASE"] = "dense_deposit_disease";
    DiagnosisBaselineDisease["MEMBRANOUS_NEPHROPATHY"] = "membranous_nephropathy";
    DiagnosisBaselineDisease["MEMBRANO_PROLIFERATIVE"] = "membrano_proliferative";
    DiagnosisBaselineDisease["CRESCENTIC"] = "crescentic";
    DiagnosisBaselineDisease["FOCAL_SEGMENTAL_GLOMERULOSCLEROSIS_IN_ADULTS"] = "focal_segmental_glomerulosclerosis_in_adults";
    DiagnosisBaselineDisease["GLOMERULONEPHRITIS_HISTOLOGICALLY_EXAMINED"] = "glomerulonephritis_histologically_examined";
    DiagnosisBaselineDisease["PYELONEPHRITIS_CAUSE_NOT_SPECIFIED"] = "pyelonephritis_cause_not_specified";
    DiagnosisBaselineDisease["PYELONEPHRITIS_ASSOCIATED_WITH_NEUROGENIC_BLADDER"] = "pyelonephritis_associated_with_neurogenic_bladder";
    DiagnosisBaselineDisease["PYELONEPHRITIS_DUE_TO_CONGENITAL_OBSTRUCTIVE_UROPATHY"] = "pyelonephritis_due_to_congenital_obstructive_uropathy";
    DiagnosisBaselineDisease["PYELONEPHRITIS_DUE_TO_ACQUIRED_OBSTRUCTIVE_UROPATHY"] = "pyelonephritis_due_to_acquired_obstructive_uropathy";
    DiagnosisBaselineDisease["PYELONEPHRITIS_DUE_TO_VESICO_URETERIC_REFLUX_WITHOUT_OBSTRUCTION"] = "pyelonephritis_due_to_vesico-ureteric_reflux_without_obstruction";
    DiagnosisBaselineDisease["PYELONEPHRITIS_DUE_TO_UROLITHIASIS"] = "pyelonephritis_due_to_urolithiasis";
    DiagnosisBaselineDisease["PYELONEPHRITIS_DUE_TO_OTHER_CAUSE"] = "pyelonephritis_due_to_other_cause";
    DiagnosisBaselineDisease["INTERSTITIAL_NEPHRITIS_NOT_PYELONEPHRITIS"] = "interstitial_nephritis_not_pyelonephritis";
    DiagnosisBaselineDisease["NEPHROPATHY_INTERSTITIAL_DUE_TO_ANALGESIC_DRUGS"] = "nephropathy_interstitial_due_to_analgesic_drugs";
    DiagnosisBaselineDisease["NEPHROPATHY_INTERSTITIAL_DUE_TO_CIS_PLATINUM"] = "Nephropathy_interstitial_due_to_cis-platinum";
    DiagnosisBaselineDisease["NEPHROPATHY_INTERSTITIAL_DUE_TO_CYCLOSPORIN_A"] = "nephropathy_interstitial_due_to_cyclosporin_A";
    DiagnosisBaselineDisease["LEAD_INDUCED_NEPHROPATHY_INTERSTITIAL"] = "Lead_induced_nephropathy_interstitial";
    DiagnosisBaselineDisease["DRUG_INDUCED_NEPHROPATHY"] = "drug_induced_nephropathy";
    DiagnosisBaselineDisease["CYSTIC_KIDNEY_DISEASE_UNSPECIFIED"] = "cystic_kidney_disease_unspecified";
    DiagnosisBaselineDisease["POLYCYSTIC_KIDNEYS_ADULT_TYPE"] = "polycystic_kidneys_adult_type";
    DiagnosisBaselineDisease["POLYCYSTIC_KIDNEYS_INFANTILE"] = "polycystic_kidneys_infantile";
    DiagnosisBaselineDisease["MEDULLARY_CYSTIC_DISEASE"] = "medullary_cystic_disease";
    DiagnosisBaselineDisease["CYSTIC_KIDNEY_DISEASE_OTHER_SPECIFIED"] = "cystic_kidney_disease_other_specified";
    DiagnosisBaselineDisease["HEREDITARY_FAMILIAL_NEPHROPATHY"] = "hereditary_Familial_nephropathy";
    DiagnosisBaselineDisease["HEREDITARY_NEPHRITIS_WITH_NERVE_DEAFNESS"] = "hereditary_nephritis_with_nerve_deafness";
    DiagnosisBaselineDisease["CYSTINOSIS"] = "cystinosis";
    DiagnosisBaselineDisease["PRIMARY_OXALOSIS"] = "primary_oxalosis";
    DiagnosisBaselineDisease["FABRYS_DISEASE"] = "fabrys_disease";
    DiagnosisBaselineDisease["HEREDITARY_NEPHROPATHY"] = "hereditary_nephropathy";
    DiagnosisBaselineDisease["RENAL_HYPOPLASIA_CONGENITAL"] = "renal_hypoplasia_congenital";
    DiagnosisBaselineDisease["OLIGOMEGANEPHRONIC_HYPOPLASIA"] = "oligomeganephronic_hypoplasia";
    DiagnosisBaselineDisease["CONGENITAL_RENAL_DYSPLASIA"] = "congenital_renal_dysplasia";
    DiagnosisBaselineDisease["SYNDROME_OF_AGENESIS_OF_ABDOMINAL_MUSCLES"] = "syndrome_of_agenesis_of_abdominal_muscles";
    DiagnosisBaselineDisease["RENAL_VASCULAR_DISEASE_TYPE_UNSPECIFIED"] = "renal_vascular_disease_type_unspecified";
    DiagnosisBaselineDisease["RENAL_VASCULAR_DISEASE_DUE_TO_MALIGNANT_HYPERTENSION"] = "renal_vascular_disease_due_to_malignant_hypertension";
    DiagnosisBaselineDisease["RENAL_VASCULAR_DISEASE_DUE_TO_HYPERTENSION"] = "renal_vascular_disease_due_to_hypertension";
    DiagnosisBaselineDisease["RENAL_VASCULAR_DISEASE_DUE_TO_POLYARTERITIS"] = "renal_vascular_disease_due_to_polyarteritis";
    DiagnosisBaselineDisease["WEGENERS_GRANULOMATOSIS"] = "wegeners_granulomatosis";
    DiagnosisBaselineDisease["ISCHAEMIC_RENAL_DISEASE"] = "ischaemic_renal_disease";
    DiagnosisBaselineDisease["GLOMERULONEPHRITIS_RELATED_TO_LIVER_CIRRHOSIS"] = "glomerulonephritis_related_to_liver_cirrhosis";
    DiagnosisBaselineDisease["CRYOGLOBULINAEMIC_GLOMERULONEPHRITIS"] = "cryoglobulinaemic_glomerulonephritis";
    DiagnosisBaselineDisease["RENAL_VASCULAR_DISEASE_DUE_TO_OTHER_CAUSE"] = "renal_vascular_disease_due_to_other_cause";
    DiagnosisBaselineDisease["DIABETES_TYPE_I"] = "diabetes_type_I";
    DiagnosisBaselineDisease["DIABETES_TYPE_II"] = "diabetes_type_II";
    DiagnosisBaselineDisease["MYELOMATOSIS"] = "myelomatosis";
    DiagnosisBaselineDisease["AMYLOID"] = "amyloid";
    DiagnosisBaselineDisease["LUPUS_ERYTHEMATOSUS"] = "lupus_erythematosus";
    DiagnosisBaselineDisease["HENOCH_SCHOENLEIN_PURPURA"] = "henoch_Schoenlein_purpura";
    DiagnosisBaselineDisease["GOODPASTURES_SYNDROME"] = "goodpastures_syndrome";
    DiagnosisBaselineDisease["SYSTEMIC_SCLEROSIS"] = "systemic_sclerosis";
    DiagnosisBaselineDisease["HAEMOLYTIC_URAEMIC_SYNDROME"] = "haemolytic_uraemic_syndrome";
    DiagnosisBaselineDisease["MULTI_SYSTEM_DISEASE_OTHER"] = "multi_system_disease_other";
    DiagnosisBaselineDisease["TUBULAR_NECROSIS_IRREVERSIBLE"] = "tubular_necrosis_irreversible";
    DiagnosisBaselineDisease["TUBERCULOSIS"] = "tuberculosis";
    DiagnosisBaselineDisease["GOUT"] = "gout";
    DiagnosisBaselineDisease["NEPHROCALCINOSIS_HYPERCALCAEMIC_NEPHROPATHY"] = "nephrocalcinosis_hypercalcaemic_nephropathy";
    DiagnosisBaselineDisease["BALKAN_NEPHROPATHY"] = "balkan_nephropathy";
    DiagnosisBaselineDisease["KIDNEY_TUMOUR"] = "kidney_tumour";
    DiagnosisBaselineDisease["TRAUMATIC_OR_SURGICAL_LOSS_OF_KIDNEY"] = "traumatic_or_surgical_loss_of_kidney";
    DiagnosisBaselineDisease["OTHER_IDENTIFIED_RENAL_DISORDERS"] = "other_identified_renal_disorders";
})(DiagnosisBaselineDisease || (exports.DiagnosisBaselineDisease = DiagnosisBaselineDisease = {}));
var KidneyCoreBiopsy;
(function (KidneyCoreBiopsy) {
    KidneyCoreBiopsy["PERFORMED"] = "PERFORMED";
    KidneyCoreBiopsy["NOT_PERFORMED"] = "NOT_PERFORMED";
})(KidneyCoreBiopsy || (exports.KidneyCoreBiopsy = KidneyCoreBiopsy = {}));
exports.diagnosisBaselineDiseaseMessages = {
    [DiagnosisBaselineDisease.CHRONIC_RENAL_FAILURE]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.CHRONIC_RENAL_FAILURE",
        defaultMessage: "00 - Krónikus vese károsodás - ismeretlen etiológia"
    },
    [DiagnosisBaselineDisease.GLOMERULONEPHRITIS_HISTOLOGICALLY_NOT_EXAMINED]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.GLOMERULONEPHRITIS_HISTOLOGICALLY_NOT_EXAMINED",
        defaultMessage: "10 - Glomerulonephritis - szövettanilag nem vizsgált"
    },
    [DiagnosisBaselineDisease.FOCAL_SEGMENTAL_GLOMERULOSCLEROSIS_IN_CHILDREN]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.FOCAL_SEGMENTAL_GLOMERULOSCLEROSIS_IN_CHILDREN",
        defaultMessage: "11 - Fokális szegmentális glomerulosclerosis nefrózis szindromával gyermekkorban"
    },
    [DiagnosisBaselineDisease.IG_A_NEPHROPATHY]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.IG_A_NEPHROPATHY",
        defaultMessage: "12 - IgA nefropathia (immunfluoreszcenciával igazolt)"
    },
    [DiagnosisBaselineDisease.DENSE_DEPOSIT_DISEASE]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.DENSE_DEPOSIT_DISEASE",
        defaultMessage: "13 - Dens depozit betegség MPGN - II típus"
    },
    [DiagnosisBaselineDisease.MEMBRANOUS_NEPHROPATHY]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.MEMBRANOUS_NEPHROPATHY",
        defaultMessage: "14 - Membranozus nefropathia"
    },
    [DiagnosisBaselineDisease.MEMBRANO_PROLIFERATIVE]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.MEMBRANO_PROLIFERATIVE",
        defaultMessage: "15 - Membranoproliferatív glomerulonephritis - I típus"
    },
    [DiagnosisBaselineDisease.CRESCENTIC]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.CRESCENTIC",
        defaultMessage: "16 - Rapidan progresszív glomerulonephritis szisztémás betegség nélkül"
    },
    [DiagnosisBaselineDisease.FOCAL_SEGMENTAL_GLOMERULOSCLEROSIS_IN_ADULTS]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.FOCAL_SEGMENTAL_GLOMERULOSCLEROSIS_IN_ADULTS",
        defaultMessage: "17 - Fokális szegmentális glomerulosclerosis nefrózis szindrómával felnőttkorban"
    },
    [DiagnosisBaselineDisease.GLOMERULONEPHRITIS_HISTOLOGICALLY_EXAMINED]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.GLOMERULONEPHRITIS_HISTOLOGICALLY_EXAMINED",
        defaultMessage: "19 - Glomerulonephritis - szövettanilag vizsgált"
    },
    [DiagnosisBaselineDisease.PYELONEPHRITIS_CAUSE_NOT_SPECIFIED]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.PYELONEPHRITIS_CAUSE_NOT_SPECIFIED",
        defaultMessage: "20 - Pyelonephritis/Interstitialis nephritis - ok nem tisztázott"
    },
    [DiagnosisBaselineDisease.PYELONEPHRITIS_ASSOCIATED_WITH_NEUROGENIC_BLADDER]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.PYELONEPHRITIS_ASSOCIATED_WITH_NEUROGENIC_BLADDER",
        defaultMessage: "21 - Pyelonephritis/Interstitialis nephritis - neurogén hólyag"
    },
    [DiagnosisBaselineDisease.PYELONEPHRITIS_DUE_TO_CONGENITAL_OBSTRUCTIVE_UROPATHY]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.PYELONEPHRITIS_DUE_TO_CONGENITAL_OBSTRUCTIVE_UROPATHY",
        defaultMessage: "22 - Pyelonephritis/Interstitialis nephritis - kongenitalis obstruktiv uropathia"
    },
    [DiagnosisBaselineDisease.PYELONEPHRITIS_DUE_TO_ACQUIRED_OBSTRUCTIVE_UROPATHY]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.PYELONEPHRITIS_DUE_TO_ACQUIRED_OBSTRUCTIVE_UROPATHY",
        defaultMessage: "23 - Pyelonephritis/Interstitial nephritis -  szerzett obstruktiv uropathia"
    },
    [DiagnosisBaselineDisease.PYELONEPHRITIS_DUE_TO_VESICO_URETERIC_REFLUX_WITHOUT_OBSTRUCTION]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.PYELONEPHRITIS_DUE_TO_VESICO_URETERIC_REFLUX_WITHOUT_OBSTRUCTION",
        defaultMessage: "24 - Pyelonephritis/Interstitialis nephritis - VU reflux obstrukció nélkül"
    },
    [DiagnosisBaselineDisease.PYELONEPHRITIS_DUE_TO_UROLITHIASIS]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.PYELONEPHRITIS_DUE_TO_UROLITHIASIS",
        defaultMessage: "25 - Pyelonephritis/Interstitialis nephritis - urolithiasis"
    },
    [DiagnosisBaselineDisease.PYELONEPHRITIS_DUE_TO_OTHER_CAUSE]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.PYELONEPHRITIS_DUE_TO_OTHER_CAUSE",
        defaultMessage: "29 - Pyelonephritis/Interstitialis nephritis - egyéb ok"
    },
    [DiagnosisBaselineDisease.INTERSTITIAL_NEPHRITIS_NOT_PYELONEPHRITIS]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.INTERSTITIAL_NEPHRITIS_NOT_PYELONEPHRITIS",
        defaultMessage: "30 - Tubulo-interstitialis nephritis (nem pyelonephritis)"
    },
    [DiagnosisBaselineDisease.NEPHROPATHY_INTERSTITIAL_DUE_TO_ANALGESIC_DRUGS]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.NEPHROPATHY_INTERSTITIAL_DUE_TO_ANALGESIC_DRUGS",
        defaultMessage: "31 - Nefropathia analgetikus szer miatt"
    },
    [DiagnosisBaselineDisease.NEPHROPATHY_INTERSTITIAL_DUE_TO_CIS_PLATINUM]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.NEPHROPATHY_INTERSTITIAL_DUE_TO_CIS_PLATINUM",
        defaultMessage: "32 - Nefropathia cisplatin miatt"
    },
    [DiagnosisBaselineDisease.NEPHROPATHY_INTERSTITIAL_DUE_TO_CYCLOSPORIN_A]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.NEPHROPATHY_INTERSTITIAL_DUE_TO_CYCLOSPORIN_A",
        defaultMessage: "33 - Nefropathia Cyclosporin A miatt"
    },
    [DiagnosisBaselineDisease.LEAD_INDUCED_NEPHROPATHY_INTERSTITIAL]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.LEAD_INDUCED_NEPHROPATHY_INTERSTITIAL",
        defaultMessage: "34 - Ólom indukálta interstitialis nephropathia"
    },
    [DiagnosisBaselineDisease.DRUG_INDUCED_NEPHROPATHY]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.DRUG_INDUCED_NEPHROPATHY",
        defaultMessage: "39 - Egyéb specifikus szer okozta nephropathia"
    },
    [DiagnosisBaselineDisease.CYSTIC_KIDNEY_DISEASE_UNSPECIFIED]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.CYSTIC_KIDNEY_DISEASE_UNSPECIFIED",
        defaultMessage: "40 - Cystas vesebetegség - nem azonosított típus"
    },
    [DiagnosisBaselineDisease.POLYCYSTIC_KIDNEYS_ADULT_TYPE]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.POLYCYSTIC_KIDNEYS_ADULT_TYPE",
        defaultMessage: "41 - Polycystas vese - Felnőttkori (domináns)"
    },
    [DiagnosisBaselineDisease.POLYCYSTIC_KIDNEYS_INFANTILE]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.POLYCYSTIC_KIDNEYS_INFANTILE",
        defaultMessage: "42 - Polycystas vese - Gyermekkori (recesszív)"
    },
    [DiagnosisBaselineDisease.MEDULLARY_CYSTIC_DISEASE]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.MEDULLARY_CYSTIC_DISEASE",
        defaultMessage: "43 - Medullaris cystas betegség - nephronophtisis"
    },
    [DiagnosisBaselineDisease.CYSTIC_KIDNEY_DISEASE_OTHER_SPECIFIED]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.CYSTIC_KIDNEY_DISEASE_OTHER_SPECIFIED",
        defaultMessage: "49 - Cystas vesebetegség - Egyéb specifikus típus"
    },
    [DiagnosisBaselineDisease.HEREDITARY_FAMILIAL_NEPHROPATHY]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.HEREDITARY_FAMILIAL_NEPHROPATHY",
        defaultMessage: "50 - Herediter/Familiaris nephropathia - nem azonosított típus"
    },
    [DiagnosisBaselineDisease.HEREDITARY_NEPHRITIS_WITH_NERVE_DEAFNESS]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.HEREDITARY_NEPHRITIS_WITH_NERVE_DEAFNESS",
        defaultMessage: "51 - Herediter nephritis idegi hallásvesztéssel (Alport-szindróma)"
    },
    [DiagnosisBaselineDisease.CYSTINOSIS]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.CYSTINOSIS",
        defaultMessage: "52 - Cystinosis"
    },
    [DiagnosisBaselineDisease.PRIMARY_OXALOSIS]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.PRIMARY_OXALOSIS",
        defaultMessage: "53 - Primer oxalosis"
    },
    [DiagnosisBaselineDisease.FABRYS_DISEASE]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.FABRYS_DISEASE",
        defaultMessage: "54 - Fabry-kór"
    },
    [DiagnosisBaselineDisease.HEREDITARY_NEPHROPATHY]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.HEREDITARY_NEPHROPATHY",
        defaultMessage: "59 - Herediter nephropathia - Egyéb"
    },
    [DiagnosisBaselineDisease.RENAL_HYPOPLASIA_CONGENITAL]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.RENAL_HYPOPLASIA_CONGENITAL",
        defaultMessage: "60 - Congenitalis vese hypoplasia - nem azonosított típus"
    },
    [DiagnosisBaselineDisease.OLIGOMEGANEPHRONIC_HYPOPLASIA]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.OLIGOMEGANEPHRONIC_HYPOPLASIA",
        defaultMessage: "61 - Oligomeganephronos hypoplasia"
    },
    [DiagnosisBaselineDisease.CONGENITAL_RENAL_DYSPLASIA]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.CONGENITAL_RENAL_DYSPLASIA",
        defaultMessage: "63 - Congenitalis vese dysplasia vizeletelvezető traktus malformációval vagy anélkül"
    },
    [DiagnosisBaselineDisease.SYNDROME_OF_AGENESIS_OF_ABDOMINAL_MUSCLES]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.SYNDROME_OF_AGENESIS_OF_ABDOMINAL_MUSCLES",
        defaultMessage: "66 - Hasi izomzat agenesia szindróma (Prune Belly szindróma)"
    },
    [DiagnosisBaselineDisease.RENAL_VASCULAR_DISEASE_TYPE_UNSPECIFIED]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.RENAL_VASCULAR_DISEASE_TYPE_UNSPECIFIED",
        defaultMessage: "70 - Renalis vaszkularis betegség - nem azonosított típus"
    },
    [DiagnosisBaselineDisease.RENAL_VASCULAR_DISEASE_DUE_TO_MALIGNANT_HYPERTENSION]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.RENAL_VASCULAR_DISEASE_DUE_TO_MALIGNANT_HYPERTENSION",
        defaultMessage: "71 - Renalis vaszkularis betegség - malignus hypertonia miatt"
    },
    [DiagnosisBaselineDisease.RENAL_VASCULAR_DISEASE_DUE_TO_HYPERTENSION]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.RENAL_VASCULAR_DISEASE_DUE_TO_HYPERTENSION",
        defaultMessage: "72 - Renalis vaszkularis betegség - hypertonia miatt"
    },
    [DiagnosisBaselineDisease.RENAL_VASCULAR_DISEASE_DUE_TO_POLYARTERITIS]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.RENAL_VASCULAR_DISEASE_DUE_TO_POLYARTERITIS",
        defaultMessage: "73 - Renalis vaszkularis betegség - polyarteritis miatt"
    },
    [DiagnosisBaselineDisease.WEGENERS_GRANULOMATOSIS]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.WEGENERS_GRANULOMATOSIS",
        defaultMessage: "74 - Granulomatosis polyangiitissel (Wegener granulomatosis)"
    },
    [DiagnosisBaselineDisease.ISCHAEMIC_RENAL_DISEASE]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.ISCHAEMIC_RENAL_DISEASE",
        defaultMessage: "75 - Ischemias vesebetegség / cholesterol embolisatio"
    },
    [DiagnosisBaselineDisease.GLOMERULONEPHRITIS_RELATED_TO_LIVER_CIRRHOSIS]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.GLOMERULONEPHRITIS_RELATED_TO_LIVER_CIRRHOSIS",
        defaultMessage: "76 - Glomerulonephritis - máj cirrhosishoz társuló"
    },
    [DiagnosisBaselineDisease.CRYOGLOBULINAEMIC_GLOMERULONEPHRITIS]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.CRYOGLOBULINAEMIC_GLOMERULONEPHRITIS",
        defaultMessage: "78 - Kryoglobulinaemias glomerulonephritis"
    },
    [DiagnosisBaselineDisease.RENAL_VASCULAR_DISEASE_DUE_TO_OTHER_CAUSE]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.RENAL_VASCULAR_DISEASE_DUE_TO_OTHER_CAUSE",
        defaultMessage: "79 - Renalis vaszkularis betegség - azonosított"
    },
    [DiagnosisBaselineDisease.DIABETES_TYPE_I]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.DIABETES_TYPE_I",
        defaultMessage: "80 - Diabetes - I típus"
    },
    [DiagnosisBaselineDisease.DIABETES_TYPE_II]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.DIABETES_TYPE_II",
        defaultMessage: "81 - Diabetes - II típus"
    },
    [DiagnosisBaselineDisease.MYELOMATOSIS]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.MYELOMATOSIS",
        defaultMessage: "82 - Myelomatosis - könnyűlánc deposit betegség"
    },
    [DiagnosisBaselineDisease.AMYLOID]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.AMYLOID",
        defaultMessage: "83 - Amyloidosis"
    },
    [DiagnosisBaselineDisease.LUPUS_ERYTHEMATOSUS]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.LUPUS_ERYTHEMATOSUS",
        defaultMessage: "84 - Lupus Erythematosus"
    },
    [DiagnosisBaselineDisease.HENOCH_SCHOENLEIN_PURPURA]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.HENOCH_SCHOENLEIN_PURPURA",
        defaultMessage: "85 - Henoch-Schönlein Purpura"
    },
    [DiagnosisBaselineDisease.GOODPASTURES_SYNDROME]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.GOODPASTURES_SYNDROME",
        defaultMessage: "86 - Goodpasture szindróma"
    },
    [DiagnosisBaselineDisease.SYSTEMIC_SCLEROSIS]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.SYSTEMIC_SCLEROSIS",
        defaultMessage: "87 - Szisztemas sclerosis"
    },
    [DiagnosisBaselineDisease.HAEMOLYTIC_URAEMIC_SYNDROME]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.HAEMOLYTIC_URAEMIC_SYNDROME",
        defaultMessage: "88 - Hemolitikus Uraemias Szindróma beleértve a Moskowitz szindromát"
    },
    [DiagnosisBaselineDisease.MULTI_SYSTEM_DISEASE_OTHER]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.MULTI_SYSTEM_DISEASE_OTHER",
        defaultMessage: "89 - Multiszisztema betegség - egyéb specifikus típus"
    },
    [DiagnosisBaselineDisease.TUBULAR_NECROSIS_IRREVERSIBLE]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.TUBULAR_NECROSIS_IRREVERSIBLE",
        defaultMessage: "90 - Kortikalis vagy tubuláris nekrózis"
    },
    [DiagnosisBaselineDisease.TUBERCULOSIS]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.TUBERCULOSIS",
        defaultMessage: "91 - Tuberkulózis"
    },
    [DiagnosisBaselineDisease.GOUT]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.GOUT",
        defaultMessage: "92 - Urát nephropathia (köszvény)"
    },
    [DiagnosisBaselineDisease.NEPHROCALCINOSIS_HYPERCALCAEMIC_NEPHROPATHY]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.NEPHROCALCINOSIS_HYPERCALCAEMIC_NEPHROPATHY",
        defaultMessage: "93 - Nephrocalcinosis és hypercalcaemias nephropathia"
    },
    [DiagnosisBaselineDisease.BALKAN_NEPHROPATHY]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.BALKAN_NEPHROPATHY",
        defaultMessage: "94 - Balkan nephritis"
    },
    [DiagnosisBaselineDisease.KIDNEY_TUMOUR]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.KIDNEY_TUMOUR",
        defaultMessage: "95 - Vese tumor"
    },
    [DiagnosisBaselineDisease.TRAUMATIC_OR_SURGICAL_LOSS_OF_KIDNEY]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.TRAUMATIC_OR_SURGICAL_LOSS_OF_KIDNEY",
        defaultMessage: "96 - Traumás vagy sebészeti vese vesztés"
    },
    [DiagnosisBaselineDisease.OTHER_IDENTIFIED_RENAL_DISORDERS]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.diagnosisBaselineDisease.OTHER_IDENTIFIED_RENAL_DISORDERS",
        defaultMessage: "99 - Egyéb azonosított veserendellenesség - specifikus"
    }
};
exports.kidneyCoreBiopsyMessages = {
    [KidneyCoreBiopsy.PERFORMED]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.kidneyCoreBiopsy.PERFORMED",
        defaultMessage: "Történt"
    },
    [KidneyCoreBiopsy.NOT_PERFORMED]: {
        id: "ktx.basicRegistrationData.waitingListData.kidneyDiseaseEthiology.kidneyCoreBiopsy.NOT_PERFORMED",
        defaultMessage: "Nem történt"
    }
};
const diagnosisBaselineDisease = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.CHRONIC_RENAL_FAILURE)
        .interpretation({ vocab: "ktx", code: "chronic_renal_failure" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.GLOMERULONEPHRITIS_HISTOLOGICALLY_NOT_EXAMINED)
        .interpretation({
        vocab: "ktx",
        code: "glomerulonephritis_histologically_not_examined"
    })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.FOCAL_SEGMENTAL_GLOMERULOSCLEROSIS_IN_CHILDREN)
        .interpretation({
        vocab: "ktx",
        code: "focal_segmental_glomerulosclerosis_in_children"
    })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.IG_A_NEPHROPATHY)
        .interpretation({ vocab: "ktx", code: "IgA_nephropathy" })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.DENSE_DEPOSIT_DISEASE)
        .interpretation({ vocab: "ktx", code: "dense_deposit_disease" })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.MEMBRANOUS_NEPHROPATHY)
        .interpretation({ vocab: "ktx", code: "membranous_nephropathy" })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.MEMBRANO_PROLIFERATIVE)
        .interpretation({ vocab: "ktx", code: "membrano_proliferative" })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.CRESCENTIC)
        .interpretation({ vocab: "ktx", code: "crescentic" })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.FOCAL_SEGMENTAL_GLOMERULOSCLEROSIS_IN_ADULTS)
        .interpretation({
        vocab: "ktx",
        code: "focal_segmental_glomerulosclerosis_in_adults"
    })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.GLOMERULONEPHRITIS_HISTOLOGICALLY_EXAMINED)
        .interpretation({
        vocab: "ktx",
        code: "glomerulonephritis_histologically_examined"
    })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.PYELONEPHRITIS_CAUSE_NOT_SPECIFIED)
        .interpretation({
        vocab: "ktx",
        code: "pyelonephritis_cause_not_specified"
    })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.PYELONEPHRITIS_ASSOCIATED_WITH_NEUROGENIC_BLADDER)
        .interpretation({
        vocab: "ktx",
        code: "pyelonephritis_associated_with_neurogenic_bladder"
    })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.PYELONEPHRITIS_DUE_TO_CONGENITAL_OBSTRUCTIVE_UROPATHY)
        .interpretation({
        vocab: "ktx",
        code: "pyelonephritis_due_to_congenital_obstructive_uropathy"
    })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.PYELONEPHRITIS_DUE_TO_ACQUIRED_OBSTRUCTIVE_UROPATHY)
        .interpretation({
        vocab: "ktx",
        code: "pyelonephritis_due_to_acquired_obstructive_uropathy"
    })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.PYELONEPHRITIS_DUE_TO_VESICO_URETERIC_REFLUX_WITHOUT_OBSTRUCTION)
        .interpretation({
        vocab: "ktx",
        code: "pyelonephritis_due_to_vesico-ureteric_reflux_without_obstruction"
    })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.PYELONEPHRITIS_DUE_TO_UROLITHIASIS)
        .interpretation({
        vocab: "ktx",
        code: "pyelonephritis_due_to_urolithiasis"
    })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.PYELONEPHRITIS_DUE_TO_OTHER_CAUSE)
        .interpretation({
        vocab: "ktx",
        code: "pyelonephritis_due_to_other_cause"
    })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.INTERSTITIAL_NEPHRITIS_NOT_PYELONEPHRITIS)
        .interpretation({
        vocab: "ktx",
        code: "interstitial_nephritis_not_pyelonephritis"
    })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.NEPHROPATHY_INTERSTITIAL_DUE_TO_ANALGESIC_DRUGS)
        .interpretation({
        vocab: "ktx",
        code: "nephropathy_interstitial_due_to_analgesic_drugs"
    })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.NEPHROPATHY_INTERSTITIAL_DUE_TO_CIS_PLATINUM)
        .interpretation({
        vocab: "ktx",
        code: "Nephropathy_interstitial_due_to_cis-platinum"
    })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.NEPHROPATHY_INTERSTITIAL_DUE_TO_CYCLOSPORIN_A)
        .interpretation({
        vocab: "ktx",
        code: "nephropathy_interstitial_due_to_cyclosporin_A"
    })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.LEAD_INDUCED_NEPHROPATHY_INTERSTITIAL)
        .interpretation({
        vocab: "ktx",
        code: "Lead_induced_nephropathy_interstitial"
    })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.DRUG_INDUCED_NEPHROPATHY)
        .interpretation({ vocab: "ktx", code: "drug_induced_nephropathy" })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.CYSTIC_KIDNEY_DISEASE_UNSPECIFIED)
        .interpretation({
        vocab: "ktx",
        code: "cystic_kidney_disease_unspecified"
    })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.POLYCYSTIC_KIDNEYS_ADULT_TYPE)
        .interpretation({ vocab: "ktx", code: "polycystic_kidneys_adult_type" })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.POLYCYSTIC_KIDNEYS_INFANTILE)
        .interpretation({ vocab: "ktx", code: "polycystic_kidneys_infantile" })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.MEDULLARY_CYSTIC_DISEASE)
        .interpretation({ vocab: "ktx", code: "medullary_cystic_disease" })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.CYSTIC_KIDNEY_DISEASE_OTHER_SPECIFIED)
        .interpretation({
        vocab: "ktx",
        code: "cystic_kidney_disease_other_specified"
    })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.HEREDITARY_FAMILIAL_NEPHROPATHY)
        .interpretation({
        vocab: "ktx",
        code: "hereditary_Familial_nephropathy"
    })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.HEREDITARY_NEPHRITIS_WITH_NERVE_DEAFNESS)
        .interpretation({
        vocab: "ktx",
        code: "hereditary_nephritis_with_nerve_deafness"
    })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.CYSTINOSIS)
        .interpretation({ vocab: "ktx", code: "cystinosis" })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.PRIMARY_OXALOSIS)
        .interpretation({ vocab: "ktx", code: "primary_oxalosis" })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.FABRYS_DISEASE)
        .interpretation({ vocab: "ktx", code: "fabrys_disease" })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.HEREDITARY_NEPHROPATHY)
        .interpretation({ vocab: "ktx", code: "hereditary_nephropathy" })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.RENAL_HYPOPLASIA_CONGENITAL)
        .interpretation({ vocab: "ktx", code: "renal_hypoplasia_congenital" })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.OLIGOMEGANEPHRONIC_HYPOPLASIA)
        .interpretation({ vocab: "ktx", code: "oligomeganephronic_hypoplasia" })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.CONGENITAL_RENAL_DYSPLASIA)
        .interpretation({ vocab: "ktx", code: "congenital_renal_dysplasia" })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.SYNDROME_OF_AGENESIS_OF_ABDOMINAL_MUSCLES)
        .interpretation({
        vocab: "ktx",
        code: "syndrome_of_agenesis_of_abdominal_muscles"
    })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.RENAL_VASCULAR_DISEASE_TYPE_UNSPECIFIED)
        .interpretation({
        vocab: "ktx",
        code: "renal_vascular_disease_type_unspecified"
    })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.RENAL_VASCULAR_DISEASE_DUE_TO_MALIGNANT_HYPERTENSION)
        .interpretation({
        vocab: "ktx",
        code: "renal_vascular_disease_due_to_malignant_hypertension"
    })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.RENAL_VASCULAR_DISEASE_DUE_TO_HYPERTENSION)
        .interpretation({
        vocab: "ktx",
        code: "renal_vascular_disease_due_to_hypertension"
    })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.RENAL_VASCULAR_DISEASE_DUE_TO_POLYARTERITIS)
        .interpretation({
        vocab: "ktx",
        code: "renal_vascular_disease_due_to_polyarteritis"
    })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.WEGENERS_GRANULOMATOSIS)
        .interpretation({ vocab: "ktx", code: "wegeners_granulomatosis" })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.ISCHAEMIC_RENAL_DISEASE)
        .interpretation({ vocab: "ktx", code: "ischaemic_renal_disease" })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.GLOMERULONEPHRITIS_RELATED_TO_LIVER_CIRRHOSIS)
        .interpretation({
        vocab: "ktx",
        code: "glomerulonephritis_related_to_liver_cirrhosis"
    })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.CRYOGLOBULINAEMIC_GLOMERULONEPHRITIS)
        .interpretation({
        vocab: "ktx",
        code: "cryoglobulinaemic_glomerulonephritis"
    })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.RENAL_VASCULAR_DISEASE_DUE_TO_OTHER_CAUSE)
        .interpretation({
        vocab: "ktx",
        code: "renal_vascular_disease_due_to_other_cause"
    })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.DIABETES_TYPE_I)
        .interpretation({ vocab: "ktx", code: "diabetes_type_I" })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.DIABETES_TYPE_II)
        .interpretation({ vocab: "ktx", code: "diabetes_type_II" })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.MYELOMATOSIS)
        .interpretation({ vocab: "ktx", code: "myelomatosis" })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.AMYLOID)
        .interpretation({ vocab: "ktx", code: "amyloid" })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.LUPUS_ERYTHEMATOSUS)
        .interpretation({ vocab: "ktx", code: "lupus_erythematosus" })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.HENOCH_SCHOENLEIN_PURPURA)
        .interpretation({ vocab: "ktx", code: "henoch_Schoenlein_purpura" })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.GOODPASTURES_SYNDROME)
        .interpretation({ vocab: "ktx", code: "goodpastures_syndrome" })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.SYSTEMIC_SCLEROSIS)
        .interpretation({ vocab: "ktx", code: "systemic_sclerosis" })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.HAEMOLYTIC_URAEMIC_SYNDROME)
        .interpretation({ vocab: "ktx", code: "haemolytic_uraemic_syndrome" })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.MULTI_SYSTEM_DISEASE_OTHER)
        .interpretation({ vocab: "ktx", code: "multi_system_disease_other" })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.TUBULAR_NECROSIS_IRREVERSIBLE)
        .interpretation({ vocab: "ktx", code: "tubular_necrosis_irreversible" })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.TUBERCULOSIS)
        .interpretation({ vocab: "ktx", code: "tuberculosis" })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.GOUT)
        .interpretation({ vocab: "ktx", code: "gout" })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.NEPHROCALCINOSIS_HYPERCALCAEMIC_NEPHROPATHY)
        .interpretation({
        vocab: "ktx",
        code: "nephrocalcinosis_hypercalcaemic_nephropathy"
    })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.BALKAN_NEPHROPATHY)
        .interpretation({ vocab: "ktx", code: "balkan_nephropathy" })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.KIDNEY_TUMOUR)
        .interpretation({ vocab: "ktx", code: "kidney_tumour" })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.TRAUMATIC_OR_SURGICAL_LOSS_OF_KIDNEY)
        .interpretation({
        vocab: "ktx",
        code: "traumatic_or_surgical_loss_of_kidney"
    })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" }),
    schema_1.Schema.singleChoiceItem(DiagnosisBaselineDisease.OTHER_IDENTIFIED_RENAL_DISORDERS)
        .interpretation({
        vocab: "ktx",
        code: "other_identified_renal_disorders"
    })
        .tag({ vocab: "snomed", code: "1119418001" })
        .tag({ vocab: "ktx", code: "kidney_disease_ethiology" })
])
    .transferInterpretationsAndTagsToParent()
    .expiration(31536000);
const kidneyCoreBiopsy = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(KidneyCoreBiopsy.PERFORMED),
    schema_1.Schema.singleChoiceItem(KidneyCoreBiopsy.NOT_PERFORMED)
]);
const kidneyCoreBiopsyComment = schema_1.Schema.string().optional().maxLength(10000);
const kidneyBiopsy = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ kidneyCoreBiopsy, kidneyCoreBiopsyComment })
    .interpretation({ vocab: "ktx", code: "kidney_biopsy" })
    .tag({ vocab: "snomed", code: "7246002" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ diagnosisBaselineDisease, kidneyBiopsy });
